import * as React from 'react';
import { cn } from '../../lib/utils';

const Select = React.forwardRef(({ className, children, ...props }, ref) => (
  <select ref={ref} className={cn('flex h-11 w-full rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-950 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-600 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50', className)} {...props}>{children}</select>
));
Select.displayName = 'Select';
export { Select };
